goog.module('yext.mvc.View');
goog.module.declareLegacyNamespace();

/**
 * @constructor
 */
const View = function() {
  /**
   * The root node of where the view should be mounted
   * @type {?jQuery}
   */
  this.$ctxt = null;

  /**
   * The root node where the view is contained.
   * @type {?jQuery}
   */
  this.$el = null;

  /**
   * The model that powers the rendering of our view
   * @type {?yext.mvc.Model}
   */
  this.model = null;
};

View.prototype.mount = function($ctxt) {
  // Allow views to be mounted into other views
  if ($ctxt instanceof View) {
    $ctxt = $ctxt.$ctxt;
  }

  this.$ctxt = $ctxt;
  this.$ctxt.append(this.$el);
  return this;
};

View.prototype.render = function() {
  throw new Error('View: .render() is not implemented.');
};

exports = View;
